"use strict";

var _regeneratorRuntime = require("/home/ubuntu/workspace/nization_roomstogatsby_master-pr/node_modules/@babel/runtime/regenerator/index.js");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YouTubePlayer = YouTubePlayer;

require("./YouTubePlayer.css");

var React = _interopRequireWildcard(require("react"));

var _tsEssentials = require("ts-essentials");

var _reactYoutube = _interopRequireDefault(require("react-youtube"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function YouTubePlayer(_ref) {
  var _document$getElements;

  var id = _ref.id,
      params = _ref.params,
      title = _ref.title,
      _ref$poster = _ref.poster,
      posterImp = _ref$poster === void 0 ? 'sddefault' : _ref$poster,
      activatedClass = _ref.activatedClass,
      adNetwork = _ref.adNetwork,
      iframeClass = _ref.iframeClass,
      playerClass = _ref.playerClass,
      onIframeAdded = _ref.onIframeAdded,
      wrapperClass = _ref.wrapperClass;

  var _useState = (0, React.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      preconnected = _useState2[0],
      setPreconnected = _useState2[1];

  var _useState3 = (0, React.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      iframe = _useState4[0],
      setIframe = _useState4[1];

  var videoId = encodeURIComponent(id);
  var videoTitle = title;
  var posterUrl = "https://i.ytimg.com/vi/".concat(videoId, "/").concat(posterImp, ".jpg");
  var ytUrl = 'https://www.youtube.com';
  var activatedClassImp = activatedClass || 'lyt-activated';
  var adNetworkImp = adNetwork || false;
  var iframeClassImp = iframeClass || '';
  var playerClassImp = playerClass || 'lty-playbtn';
  var wrapperClassImp = wrapperClass || 'yt-lite';
  var containerClassImp = 'yt-container';
  var playerWrapImp = 'yt-playerWrap';
  var pausedImgClass = 'paused';
  var onIframeAddedWithDefault = onIframeAdded || _tsEssentials.noop;

  var warmConnections = function warmConnections() {
    if (preconnected) return;
    setPreconnected(true);
  };

  var addIframe = function addIframe() {
    if (iframe) return;
    onIframeAddedWithDefault();
    setIframe(true);
  };

  var playerState = {
    UNSTARTED: -1,
    ENDED: 0,
    PLAYING: 1,
    PAUSED: 2,
    BUFFERING: 3,
    CUED: 5
  };

  var analytics = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(player, action, time) {
      var _window$dataLayer;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!videoTitle) {
                videoTitle = player.playerInfo.videoData.title;
              } // eslint-disable-next-line dot-notation


              (_window$dataLayer = window['dataLayer']) === null || _window$dataLayer === void 0 ? void 0 : _window$dataLayer.push({
                event: 'gaEvent',
                eventCategory: 'Video',
                eventAction: action,
                eventLabel: videoTitle,
                eventValue: time || 0,
                eventNI: false
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function analytics(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(React.Fragment, null, (_document$getElements = document.getElementsByClassName(playerWrapImp)[0]) === null || _document$getElements === void 0 ? void 0 : _document$getElements.classList.remove(pausedImgClass) // reset / clear paused image for ads
  , /*#__PURE__*/React.createElement("link", {
    rel: "preload",
    href: posterUrl,
    as: "image"
  }), /*#__PURE__*/React.createElement(React.Fragment, null, preconnected && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("link", {
    rel: "preconnect",
    href: ytUrl
  }), /*#__PURE__*/React.createElement("link", {
    rel: "preconnect",
    href: "https://www.google.com"
  }), adNetworkImp && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("link", {
    rel: "preconnect",
    href: "https://static.doubleclick.net"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "preconnect",
    href: "https://googleads.g.doubleclick.net"
  })))), /*#__PURE__*/React.createElement("div", {
    role: "presentation",
    onPointerOver: warmConnections,
    onClick: addIframe,
    className: "".concat(wrapperClassImp, " ").concat(iframe && activatedClassImp),
    "data-title": videoTitle,
    style: {
      backgroundImage: "url(".concat(posterUrl, ")")
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: playerClassImp
  }), iframe && /*#__PURE__*/React.createElement(_reactYoutube.default, {
    onReady: function onReady(event) {
      var _document$getElements2;

      (_document$getElements2 = document.getElementsByClassName(activatedClassImp)[0]) === null || _document$getElements2 === void 0 ? void 0 : _document$getElements2.parentElement.classList.add(playerWrapImp);
      var playerWrap = document.getElementsByClassName(playerWrapImp)[0];
      playerWrap === null || playerWrap === void 0 ? void 0 : playerWrap.addEventListener('click', function () {
        if (event.target.h) {
          var nplayerState = event.target.getPlayerState();

          if (nplayerState === playerState.ENDED) {
            event.target.seekTo(0);
          } else if (nplayerState === playerState.PAUSED) {
            event.target.playVideo();
          }
        } else {
          playerWrap.classList.remove(pausedImgClass);
        }
      });
    },
    onStateChange: /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(event) {
        var playerWrap, currentPlayTime, playDuration;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                playerWrap = document.getElementsByClassName(playerWrapImp)[0];
                _context2.next = 3;
                return event.target.getCurrentTime();

              case 3:
                currentPlayTime = _context2.sent;
                _context2.next = 6;
                return event.target.getDuration();

              case 6:
                playDuration = _context2.sent;
                _context2.t0 = event.data;
                _context2.next = _context2.t0 === playerState.ENDED ? 10 : _context2.t0 === playerState.PLAYING ? 14 : _context2.t0 === playerState.PAUSED ? 17 : _context2.t0 === playerState.BUFFERING ? 20 : _context2.t0 === playerState.CUED ? 22 : 23;
                break;

              case 10:
                event.target.stopVideo(); // prevents showing related videos at end

                analytics(event.target, 'ENDED', playDuration);
                playerWrap.classList.remove(pausedImgClass);
                return _context2.abrupt("break", 23);

              case 14:
                analytics(event.target, 'PLAY', currentPlayTime);
                setTimeout(function () {
                  playerWrap.classList.remove(pausedImgClass);
                }, 100);
                return _context2.abrupt("break", 23);

              case 17:
                analytics(event.target, 'PAUSED', currentPlayTime);
                setTimeout(function () {
                  if (playerWrap.clientWidth > 475) {
                    playerWrap.classList.add(pausedImgClass);
                  }
                }, 0);
                return _context2.abrupt("break", 23);

              case 20:
                playerWrap.classList.remove(pausedImgClass);
                return _context2.abrupt("break", 23);

              case 22:
                return _context2.abrupt("break", 23);

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x4) {
        return _ref3.apply(this, arguments);
      };
    }(),
    id: id,
    videoId: id,
    opts: {
      height: '390',
      width: '640',
      playerVars: {
        // https://developers.google.com/youtube/player_parameters
        mute: 1,
        autoplay: 1,
        // video will automatically start to play when the player loads
        cc_load_policy: 1,
        // player closed captions to be shown by default
        controls: 1,
        modestbranding: 1,
        // player that does not show a YouTube logo
        rel: 0,
        // related videos only from the same channel as the video
        loop: 1
      }
    },
    containerClassName: containerClassImp,
    className: iframeClassImp
  })));
}